enum DROPDOWN_SELECT_THEME {
  DEFAULT = 'default',
  TRANSPARENT = 'transparent',
}

export {
  DROPDOWN_SELECT_THEME,
};
